import styled from 'styled-components';

export const CampaignResult = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f4f4f4;
`;
export const Layout = styled.div`
  background: #f4f4f4;
`;
export const Body = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px 20px;
  flex: 1;
  width: 100%;
`;
export const Heading = styled.h1`
  font-weight: 100;
  margin: 0 0 50px 0;
  text-align: center;
`;
